// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  
  
  input {
    display: block;
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
    border: 1px solid white;
    padding: 10px 15px;
    margin-bottom: 10px;
    font-size: 15px;
    color: white;
  }

  .plantaddButton {
    
   text-align: center;


}
.PlantFormContainer{
    background-color: #282B30;
}


  .plantaddButton button{
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    border-radius: 0;
    color: #eee;
    margin-left: 10px;
   text-align: center;
   font-size: 10px;


}

.plantaddButton button:hover{
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}
.fieldswrapper{
    background-color: #131322;
    margin:18px;
    padding: 32px;
    width: 95%;
}`, "",{"version":3,"sources":["webpack://./src/components/PlantControl/PlantControl.css"],"names":[],"mappings":";;EAEE;IACE,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;;EAEA;;GAEC,kBAAkB;;;AAGrB;AACA;IACI,yBAAyB;AAC7B;;;EAGE;IACE,iFAAiF;IACjF,gBAAgB;IAChB,WAAW;IACX,iBAAiB;GAClB,kBAAkB;GAClB,eAAe;;;AAGlB;;AAEA;IACI,iFAAiF;AACrF;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,UAAU;AACd","sourcesContent":["  \n  \n  input {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n    border-radius: 4px;\n    border: 1px solid white;\n    padding: 10px 15px;\n    margin-bottom: 10px;\n    font-size: 15px;\n    color: white;\n  }\n\n  .plantaddButton {\n    \n   text-align: center;\n\n\n}\n.PlantFormContainer{\n    background-color: #282B30;\n}\n\n\n  .plantaddButton button{\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    border-radius: 0;\n    color: #eee;\n    margin-left: 10px;\n   text-align: center;\n   font-size: 10px;\n\n\n}\n\n.plantaddButton button:hover{\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n.fieldswrapper{\n    background-color: #131322;\n    margin:18px;\n    padding: 32px;\n    width: 95%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
